"use client"

interface ExplorerFilterTabsProps {
  activeTab: string
  onTabChange: (tab: string) => void
}

export function ExplorerFilterTabs({ activeTab, onTabChange }: ExplorerFilterTabsProps) {
  const tabs = ["Popular Careers", "My Learning Journey", "Challenges"]

  return (
    <div className="flex items-center gap-2 sm:gap-4 mb-8 flex-wrap">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onTabChange(tab)}
          className={`px-4 py-2 rounded-full font-semibold text-sm transition ${
            activeTab === tab ? "bg-blue-100 text-blue-600" : "hover:bg-slate-100 text-slate-600"
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  )
}
